import React, {FC} from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import DeleteIcon from '@pixel/assets/icons/Delete'
import IconButton from '@pixel/core/IconButton'
import Button from '@pixel/core/Button'
import { styled } from '@pixel/core/styles'
import ActionType from "./ActionType";
import useAutomationFormDataQuery from "../hooks/useAutomationFormDataQuery";
import {CircularProgress} from "@mui/material";
import LocalizedTypography from "../../components/LocalizedTypography";
import {LocalizedText} from "../../contexts/Localization/LocalizationTypes";
import {useMultipleLocalizedText} from "../../contexts/Localization/localizationHooks";

const ActionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    marginTop: theme.spacing(1),
}))

const AndContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    marginTop: theme.spacing(1),
}))

const AddActionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(1),
}))

const ActionLoadingContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
}))

interface ActionListSectionProps {

}

const ActionListSection: FC<ActionListSectionProps> = ({

}) => {
    const { control } = useFormContext()

    const { fields, append, remove, } = useFieldArray({
        control,
        name: 'companyActions',
        rules: {
            minLength: 1,
            maxLength: 3,
        }
    })

    const {
        AUTOMATION_SECTION_ADD_ACTION,
    } = useMultipleLocalizedText()


    const {
        status,
    } = useAutomationFormDataQuery({
        onSuccess: () => {},
    })

    if (status === 'loading') {
        return (
            <ActionLoadingContainer>
                <CircularProgress size="32px" />
            </ActionLoadingContainer>
        )
    }

    if (status === 'error') {
        return (
            <ActionLoadingContainer>
                <LocalizedTypography color="error" text={LocalizedText.AUTOMATION_FORM_ERROR_CONTINUE} />
            </ActionLoadingContainer>
        )
    }

    return (
        <>
            <div>
                {fields.map((field, index) => (
                <div>
                    <AndContainer>
                         {(fields.length > 1 && index > 0 && (
                             <LocalizedTypography
                                 variant="body1"
                                 color="#677074"
                                 text={LocalizedText.AndLabel}
                             />
                        ))}
                    </AndContainer>
                    <ActionContainer key={field.id}>
                        <ActionType actionTypeIndex={index}>
                            {(fields.length > 1 && (
                                <div>
                                    <IconButton id={`automation-form-action-type-field-${index}-delete-button`} onClick={() => remove(index)}><DeleteIcon/></IconButton>
                                </div>
                            ))}
                        </ActionType>
                    </ActionContainer>
                </div>
                ))}
            </div>
            <AddActionContainer>
                <Button
                    id='automation-form-add-action-button'
                    variant="outlined"
                    color="primary"
                    onClick={() => append({})}
                    disabled={fields.length >= 3}
                >
                    {AUTOMATION_SECTION_ADD_ACTION}
                </Button>
            </AddActionContainer>
        </>
    );
}

export default ActionListSection
